import React, { useState } from 'react';
import { sendMessage } from '../functions/sendMessage';

const MessageInput = ({ chat }) => {
  const [message, setMessage] = useState('');
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSendMessage = async () => {
    const hasText = message.trim().length > 0;
    const hasPhotos = selectedPhotos.length > 0;
    if (!hasText && !hasPhotos) return;

    const photosToSend = [...selectedPhotos];
    const res = await sendMessage({
      chatId: chat.id,
      photos: photosToSend,
      text: message,
    });
    if (res) {
      setSelectedPhotos([]);
      setMessage('');
    }
  };
  const handlePhotoSelect = (e) => {
    const files = e.target.files;
    if (!files) return;

    const newPhotos = Array.from(files).map((file) => ({
      uri: URL.createObjectURL(file),
      file,
    }));
    setSelectedPhotos((prevPhotos) => [...prevPhotos, ...newPhotos]);
  };

  const removePhoto = (index) => {
    setSelectedPhotos((prevPhotos) => prevPhotos.filter((_, i) => i !== index));
  };
  return (
    <>
      {selectedPhotos.length > 0 && (
        <div
          style={{
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap',
            rowGap: '16px',
            marginLeft: 10,
            marginBottom: '8px',
          }}
        >
          {selectedPhotos.map((photo, index) => (
            <div
              key={index}
              style={{ position: 'relative', width: '50px', height: '50px' }}
            >
              <img
                src={photo.uri}
                alt={`Selected ${index}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
              />
              <button
                onClick={() => removePhoto(index)}
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: 'red',
                  color: 'white',
                  borderRadius: '100%',
                  padding: 0,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 24,
                  height: 24,
                  display: 'flex',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  fontSize: 12,
                  fontWeight: 'bold',
                }}
              >
                {'X'}
              </button>
            </div>
          ))}
        </div>
      )}

      <div className='message-input'>
        <div
          style={{
            flex: 1,
            minWidth: 0,
            position: 'relative',
            display: 'flex',
          }}
        >
          <input
            type='text'
            placeholder='Введіть повідомлення...'
            value={message}
            onChange={handleInputChange}
            className='input-textarea'
            style={{
              height: 24,
            }}
            autoFocus
          />
          <input
            id='photo-upload'
            type='file'
            accept='image/*'
            multiple
            onChange={handlePhotoSelect}
            style={{ display: 'none' }}
          />
          <div
            style={{
              position: 'absolute',
              right: 16,
              top: 0,
              height: 24,
              width: 60,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              cursor: 'pointer',
            }}
          >
            <label
              htmlFor='photo-upload'
              style={{
                position: 'absolute',
                right: 0,
                top: 0,
                height: 40,
                width: 60,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                cursor: 'pointer',
              }}
            >
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M21 14H22C22 13.6552 21.8224 13.3347 21.53 13.152L21 14ZM12 4C12.5523 4 13 3.55228 13 3C13 2.44772 12.5523 2 12 2V4ZM7.27407 20.3123C6.89424 20.7132 6.91135 21.3461 7.31228 21.726C7.71321 22.1058 8.34615 22.0887 8.72598 21.6877L7.27407 20.3123ZM15.2002 13.3998L15.9261 14.0876L15.2002 13.3998ZM19.2192 12.887L19.7492 12.039L19.7492 12.039L19.2192 12.887ZM16.5461 12.2216L16.1557 11.301H16.1557L16.5461 12.2216ZM17.6206 12.0845L17.4738 13.0737L17.6206 12.0845ZM15.3119 4.34403C14.7597 4.34403 14.3119 4.79174 14.3119 5.34403C14.3119 5.89631 14.7597 6.34403 15.3119 6.34403V4.34403ZM22 6.34403C22.5523 6.34403 23 5.89631 23 5.34403C23 4.79174 22.5523 4.34403 22 4.34403V6.34403ZM19.656 2C19.656 1.44772 19.2083 1 18.656 1C18.1037 1 17.656 1.44772 17.656 2H19.656ZM17.656 8.68806C17.656 9.24034 18.1037 9.68806 18.656 9.68806C19.2083 9.68806 19.656 9.24034 19.656 8.68806H17.656ZM18 20H6V22H18V20ZM4 18V6H2V18H4ZM6 20C4.89543 20 4 19.1046 4 18H2C2 20.2091 3.79086 22 6 22V20ZM20 18C20 19.1046 19.1046 20 18 20V22C20.2091 22 22 20.2091 22 18H20ZM6 2C3.79086 2 2 3.79086 2 6H4C4 4.89543 4.89543 4 6 4V2ZM20 14V18H22V14H20ZM6 4H12V2H6V4ZM8.72598 21.6877L15.9261 14.0876L14.4742 12.7121L7.27407 20.3123L8.72598 21.6877ZM18.6892 13.735L20.47 14.848L21.53 13.152L19.7492 12.039L18.6892 13.735ZM15.9261 14.0876C16.2569 13.7385 16.4681 13.5164 16.6427 13.3576C16.8079 13.2072 16.8887 13.1626 16.9366 13.1423L16.1557 11.301C15.8195 11.4436 15.548 11.6496 15.2966 11.8784C15.0544 12.0987 14.7847 12.3843 14.4742 12.7121L15.9261 14.0876ZM19.7492 12.039C19.3664 11.7997 19.0336 11.591 18.7439 11.4385C18.4431 11.2802 18.1285 11.149 17.7673 11.0954L17.4738 13.0737C17.5253 13.0813 17.6147 13.1043 17.8124 13.2083C18.0212 13.3182 18.2814 13.4801 18.6892 13.735L19.7492 12.039ZM16.9366 13.1423C17.1059 13.0704 17.2918 13.0467 17.4738 13.0737L17.7673 11.0954C17.2214 11.0144 16.6638 11.0855 16.1557 11.301L16.9366 13.1423ZM10 9C10 9.55228 9.55228 10 9 10V12C10.6569 12 12 10.6569 12 9H10ZM9 10C8.44772 10 8 9.55228 8 9H6C6 10.6569 7.34315 12 9 12V10ZM8 9C8 8.44772 8.44772 8 9 8V6C7.34315 6 6 7.34315 6 9H8ZM9 8C9.55228 8 10 8.44772 10 9H12C12 7.34315 10.6569 6 9 6V8ZM15.3119 6.34403H18.656V4.34403H15.3119V6.34403ZM18.656 6.34403H22V4.34403H18.656V6.34403ZM17.656 2V5.34403H19.656V2H17.656ZM17.656 5.34403V8.68806H19.656V5.34403H17.656Z'
                  fill='#323232'
                />
              </svg>
            </label>
          </div>
        </div>
        <button
          type='button'
          onClick={handleSendMessage}
          disabled={
            !(message.trim().length > 0 || selectedPhotos.length > 0)
          }
          style={{
            height: 40,
            width: 40,
            opacity: !(
              message.trim().length > 0 || selectedPhotos.length > 0
            )
              ? 0.6
              : 1,
            borderRadius: 100,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <svg
            style={{ height: 24, width: 24, marginLeft: -13 }}
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M9.77954 14.2173C9.8209 14.2596 9.85977 14.3042 9.89593 14.3512C9.9846 14.4662 10.051 14.5989 10.1837 14.8644L12.2184 18.9337C13.022 20.5409 13.4238 21.3445 13.9306 21.5607C14.3705 21.7482 14.8734 21.7148 15.2846 21.4708C15.7584 21.1896 16.0505 20.3399 16.6346 18.6406L20.9563 6.06832C21.4689 4.57732 21.7251 3.83182 21.5516 3.3394C21.4795 3.13482 21.365 2.9511 21.2184 2.79854M9.77954 14.2173C9.73091 14.1677 9.67883 14.1214 9.62367 14.0789C9.50864 13.9902 9.3759 13.9239 9.11041 13.7911L5.04113 11.7565C3.43391 10.9529 2.63031 10.5511 2.41417 10.0442C2.2266 9.60437 2.25998 9.10144 2.50404 8.69023C2.78526 8.21641 3.63493 7.92434 5.33425 7.3402L17.9065 3.01849C19.3975 2.50595 20.143 2.24968 20.6354 2.42321C20.8592 2.50206 21.058 2.63166 21.2184 2.79854M9.77954 14.2173L21.2184 2.79854'
              stroke='#FFFEFD'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default MessageInput;
